import { render, staticRenderFns } from "./ProvinceTable.vue?vue&type=template&id=056cb590"
import script from "./ProvinceTable.vue?vue&type=script&lang=js"
export * from "./ProvinceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports